<template>
  <div class="wrapper">
    <div>
      <div class="item">
        <span class="left">软件名称</span>
        <span class="right"> {{ info.systemName || "--" }}</span>
      </div>
      <div class="item">
        <span class="left">语言类型</span>
        <span class="right"> {{ info.language || "--" }}</span>
      </div>
      <div class="item">
        <span class="left">软件版本</span>
        <span class="right"> {{ info.softwareVersion || "--" }}</span>
      </div>
      <div class="item">
        <span class="left">系统版本</span>
        <span class="right"> {{ info.hardwareVersion || "--" }}</span>
      </div>
      <div class="item">
        <span class="left">设备ID</span>
        <span class="right"> {{ info.deviceId || "--" }}</span>
      </div>
    </div>

    <el-button class="restart-btn restart-btn0" size="large" type="primary"
      >检查更新</el-button
    >

    <el-button
      @click="restartHandle"
      class="restart-btn"
      size="large"
      type="danger"
      >重启系统</el-button
    >
  </div>
</template>

<script>
import { ElMessageBox } from "element-plus";
export default {
  name: "Page",
  components: {},
  data: function () {
    return {
      info: {},
    };
  },
  async mounted() {
    try {
      let res = await this.$myRequest({
        url: "/list-system-info",
        method: "get",
      });
      this.info = res.data.data;
    } catch (err) {
      console.log("err");
      console.log(err);
    }
  },
  methods: {
    async restartHandle() {
      try {
        const result = await ElMessageBox.confirm("确定重启系统？", "警告", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        if (result === "confirm") {
          let res = await this.$myRequest({
            url: "/post-system-restart",
            method: "post",
          });
        }
      } catch (err) {
        console.log("err");
        console.log(err);
      }
    },
  },
};
</script>
<style scoped lang="less" src="./index.less"></style>
